/**
 * Brand-first model picker for the Doyers "Customised Case" products.
 *
 * These products carry ~400 Model option values, which the theme renders as one
 * long popover listbox. This progressively enhances that listbox into:
 *   brand grid  ->  models for the chosen brand,  plus a global type-to-filter.
 *
 * Pure enhancement: it only hides/shows the theme's own <label> options, so the
 * radio inputs, form wiring and Section Rendering API behaviour are untouched.
 * If this script fails to run, the original full list still works.
 */
(function () {
  'use strict';

  var BRANDS = [
    [/^iPhone/i, 'Apple'],
    [/^Samsung/i, 'Samsung'],
    [/^One ?plus/i, 'OnePlus'],
    [/^Nothing/i, 'Nothing'],
    [/^Google Pixel/i, 'Google Pixel'],
    [/^Vivo\s*I\s?QOO/i, 'iQOO'],   // must precede the generic Vivo rule
    [/^Vivo/i, 'Vivo'],
    [/^Oppo/i, 'Oppo'],
    [/^(Xiaomi|Mi )/i, 'Xiaomi'],
    [/^Redmi/i, 'Redmi'],
    [/^Poco/i, 'Poco'],
    [/^Realme/i, 'Realme'],
    [/^Moto/i, 'Motorola'],
    [/^Google/i, 'Google Pixel'],
    [/^Honor/i, 'Huawei'],
    [/^iQOO/i, 'iQOO'],
    [/^Tecno/i, 'Tecno'],
    [/^Infinix/i, 'Infinix'],
    [/^Lava/i, 'Lava'],
    [/^LG/i, 'LG'],
    [/^Huawei/i, 'Huawei'],
    [/^(Asus|Rog)/i, 'Asus ROG']
  ];

  // Only kick in for genuinely long lists; short ones are fine as-is.
  var MIN_OPTIONS = 40;

  function brandOf(text) {
    for (var i = 0; i < BRANDS.length; i++) {
      if (BRANDS[i][0].test(text)) return BRANDS[i][1];
    }
    return 'Other';
  }

  function norm(s) {
    return s.toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function enhance(listbox) {
    var labels = [].slice.call(listbox.querySelectorAll('label.popover-listbox__option'));
    if (labels.length < MIN_OPTIONS || listbox.dataset.cmp) return;
    listbox.dataset.cmp = '1';

    var items = labels.map(function (el) {
      var text = el.textContent.trim();
      return { el: el, text: text, key: norm(text), brand: brandOf(text) };
    });

    var order = [], byBrand = {};
    items.forEach(function (i) {
      if (!byBrand[i.brand]) { byBrand[i.brand] = []; order.push(i.brand); }
      byBrand[i.brand].push(i);
    });

    var bar = document.createElement('div');
    bar.className = 'cmp-bar';
    bar.innerHTML =
      '<input type="search" class="cmp-search" autocomplete="off" spellcheck="false" ' +
      'placeholder="Search ' + items.length + ' models\u2026" aria-label="Search phone models">' +
      '<button type="button" class="cmp-back" hidden>\u2190 All brands</button>';

    var grid = document.createElement('div');
    grid.className = 'cmp-brands';
    order.forEach(function (b) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cmp-brand';
      btn.dataset.brand = b;
      btn.innerHTML = '<span></span><em></em>';
      btn.firstChild.textContent = b;
      btn.lastChild.textContent = byBrand[b].length;
      grid.appendChild(btn);
    });

    var empty = document.createElement('p');
    empty.className = 'cmp-empty';
    empty.hidden = true;
    empty.textContent = 'No models match that search.';

    listbox.parentNode.insertBefore(bar, listbox);
    listbox.parentNode.insertBefore(grid, listbox);
    listbox.parentNode.insertBefore(empty, listbox);

    var search = bar.querySelector('.cmp-search');
    var back = bar.querySelector('.cmp-back');
    var brand = null;

    function render() {
      var q = norm(search.value), shown = 0;
      if (q) {
        grid.hidden = true; back.hidden = true;
        items.forEach(function (i) {
          var hit = i.key.indexOf(q) !== -1;
          i.el.style.display = hit ? '' : 'none';
          if (hit) shown++;
        });
        empty.hidden = shown > 0;
      } else if (brand) {
        grid.hidden = true; back.hidden = false; empty.hidden = true;
        items.forEach(function (i) { i.el.style.display = i.brand === brand ? '' : 'none'; });
      } else {
        grid.hidden = false; back.hidden = true; empty.hidden = true;
        items.forEach(function (i) { i.el.style.display = 'none'; });
      }
    }

    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.cmp-brand');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      brand = b.dataset.brand;
      render();
      search.focus();
    });

    back.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      brand = null; search.value = '';
      render();
    });

    search.addEventListener('input', render);
    // the popover closes on clicks inside the listbox - keep the field usable
    search.addEventListener('click', function (e) { e.stopPropagation(); });
    search.addEventListener('keydown', function (e) {
      e.stopPropagation();
      if (e.key === 'Escape' && search.value) { e.preventDefault(); search.value = ''; render(); }
    });

    // open on the brand of whatever is currently selected
    var checked = items.filter(function (i) {
      var input = i.el.querySelector('input');
      return input && input.checked;
    })[0];
    brand = checked ? checked.brand : null;
    render();
  }

  function scan() {
    var boxes = document.querySelectorAll('.popover-listbox[data-option-selector]');
    for (var i = 0; i < boxes.length; i++) enhance(boxes[i]);
  }

  function boot() {
    scan();
    // the theme re-renders the variant picker through the Section Rendering API
    // after every selection, which throws away the enhanced markup - re-apply.
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // setTimeout rather than rAF: rAF is throttled to zero in background or
      // non-compositing tabs, which would leave the picker un-enhanced there.
      setTimeout(function () { pending = false; scan(); }, 0);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
